export const TOAST_AUTO_HIDE_DURATION_IN_MS = 2500;

export const ENERGY_MIX_LABEL = "Energy Mix";
export const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";

export const DEFAULT_CERTIFICATE_STATUS_FILTER_ARRAY = ["live", "official"]


// WEBPACK FOOTER //
// ./src/constants/Miscellaneous.js